module.exports = __webpack_public_path__ + "static/media/zoomQuartier_Fabriques.6e45017e.webp";